export default "__VITE_ASSET__CspN5cPM__"